import { useSelector } from 'react-redux';

// @ts-ignore
import gbLocale from 'moment/locale/en-gb'; // (United Kingdom)
// @ts-ignore
import usLocale from 'moment/locale/es-us'; // (United States)
// @ts-ignore
import deLocale from 'moment/locale/de'; // German
// @ts-ignore
import esLocale from 'moment/locale/es'; // Spanish
// @ts-ignore
import cnLocale from 'moment/locale/zh-cn'; // Chinese
import { GetState, getUserLang } from '../redux/selector';
import { LANG } from '../utils/enums';

const useCheckLocale = () => {
  const hcpLang: any = useSelector<GetState>((state) => getUserLang(state));

  switch (hcpLang) {
    case LANG.EN_US:
      // return moment.locale('en-us', [usLocale]);
      return { lng: 'en-us', lacaleArr: [usLocale] };
    case LANG.DE:
      return { lng: 'de', lacaleArr: [deLocale] };
      // return moment.locale('de', [deLocale]);
    case LANG.CN:
      return { lng: 'zh-cn', lacaleArr: [cnLocale] };
    default:
      return { lng: 'en-gb', lacaleArr: [gbLocale] };
      // return moment.locale('en-gb', [gbLocale]);
  }
};

export default useCheckLocale;
